import type { WithTokenParams } from 'src/app/shared/types/index.js';
import type { PaymentType } from 'src/app/shared/utils/payments';

import type { NewPaymentMethodUpiProps } from '../../index.tsx';

type Result = ModelHookResult<
	{
		email: string;
		name: string;
		vpa: string;
		vpaValidationError: string | undefined;
	},
	{
		beforeToken: (paymentType: PaymentType) => Promise<boolean>;
		onTokenError: (paymentType: PaymentType, err: Error) => void;
		onTokenInvalid: (paymentType: PaymentType, err: Error) => void;
		validate: (paymentType: PaymentType) => Promise<boolean>;
		prePaymentChecks: (paymentType: PaymentType) => Promise<boolean>;
		withToken: (params: WithTokenParams) => Promise<void>;
		onFieldFocus: () => void;
		setVpa: (vpa: string) => void;
	}
>;

export function useNewPaymentMethodUpi({
	email,
	name,
	vpa,
	validationErrors,
	setVpa,
	validate,
	beforeToken,
	onTokenError,
	onTokenInvalid,
	withToken,
	prePaymentChecks,
	onFieldFocusUpi,
}: Omit<NewPaymentMethodUpiProps, 'submitButton' | 'countryStateSelect'>): Result {
	const data: Result['data'] = {
		name,
		email,
		vpa,
		vpaValidationError: validationErrors?.vpa,
	};

	return {
		data,
		actions: {
			beforeToken,
			onTokenError,
			onTokenInvalid,
			validate,
			prePaymentChecks,
			withToken,
			onFieldFocus: onFieldFocusUpi,
			setVpa,
		},
	};
}
